

<template>
  <!--消息中心-->
  <OpDialog
    class="opple-elf-notice-dialog"
    :visible="visible"
    :is-show-btn="false"
    @onClose="onClose"
  >
    <div
      class="opple-light-elf"
    >
      <div class="opple-light-elf-lt">
        <div class="opple-light-elf_title" />
        <img
          src="~@/assets/img/ifttt/elf.png" 
        >
      </div>
      <div class="opple-light -elf-gt">
        <div class="opple-light-elf_info">
          <p>{{ $t('ifttt.wakePro') }}</p>
        </div>
        <div class="opple-light-elf_btnList">
          <div
            class="opple-light-elf_btn blue"
            @click="onConfiguration"
          >
            {{ $t('ifttt.aWakened') }}
          </div>
        </div>
      </div>
    </div>
  </OpDialog>
</template>
<script>
import OpDialog from '../common/OpDialog';

export default {
  components: { 
    OpDialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
    }
  },

  mounted(){
  },

  created() {
  },

  methods: {
    onClose() {
      this.$emit('onClose');
    },

    async onConfiguration() {
      this.$emit('onOk')
    }
  }
}
</script>

<style lang="scss">
.opple-elf-notice-dialog {
  width: 600px;
  min-height: 206px;

  .opDialog_body {
    min-height: 206px;
    max-height: 206px;
    background: #F2F3F5;
    .opple-light-elf {
      display: flex;
      align-items: center;
      height: 100%;
      justify-content: space-between;
      
      padding: 14px 48px 20px;
      font-size: 16px;
      &-lt {
        img {
          width: 100px;
          height: 100px;
        }
      }

      &_btnList {
        justify-content: flex-end;
      }

      &_btnList {
        display: flex;
        align-items: center; 
        margin-top: 30px;
      }

      &_btn {
        min-width: 143px;
        height: 46px;    
        border-radius: 8px;
        font-size: 16px;
        line-height: 46px;
        text-align: center;
        cursor: pointer;

        &.grey {
          background: #DDDEDF;
          color: #606060;
          margin-right: 52px;
        }

        &.blue {
          background: #2145A4;
          color: #FFF;

          &.disabled {
            background: #DDDEDF;
            color: #606060;
          }
        }
      }
    }
  }
}
</style>
